import { css } from '@emotion/react';

export default css({
  '&.update-account-logo': {
    flexDirection: 'column',
    alignItems: 'start',
    display: 'block',
  },
  '.update-account-logo': {
    padding: 0,
    margin: '16px 0',
  },
});
